import type { RouteRecordRaw } from 'vue-router';

export const legacyRoutes: RouteRecordRaw[] = [
    // Legacy routes for backwards compatibility
];
